// src/components/Sidebar.js — converted from a left side panel into a
// sticky top header bar, matching the warehouse portal's Header.js style
// (logo/title row + horizontal nav-link row). Filename/export kept as
// Sidebar so App.js doesn't need an import rename.
import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

const NAV = [
  { path:'/dashboard',  label:'Dashboard',        icon:'📊' },
  { path:'/invoices',   label:'Invoices',          icon:'📋' },
  { path:'/heatmap',    label:'Heatmap',           icon:'🗂️' },
  { path:'/history',    label:'History',           icon:'📋' },
  { path:'/dispatch',   label:'Dispatch',          icon:'🚦' },
  { path:'/deliveries', label:'Live Map',          icon:'🗺️' },
  { path:'/teams',      label:'Team Management',   icon:'👥' },
  { path:'/transports', label:'Transports',        icon:'🚚' },
  { path:'/reports',    label:'Reports',           icon:'📊' },
  { path:'/marg-sync',  label:'Marg ERP Sync',     icon:'🔄' },
  { path:'/settings',   label:'Settings',          icon:'⚙️' },
];

export default function Sidebar() {
  const location = useLocation();
  const navigate  = useNavigate();
  const user = JSON.parse(localStorage.getItem('dms_user') || '{}');

  function logout() {
    localStorage.removeItem('dms_token');
    localStorage.removeItem('dms_user');
    navigate('/');
  }

  return (
    <header className="sticky top-0 z-50 bg-blue-900 text-white shadow" style={{ width: '100%' }}>
      {/* Top row: title + user + logout — same layout pattern as the
          warehouse portal's Header.js */}
      <div className="flex items-center justify-between flex-wrap gap-4 px-6 py-3">
        <div>
          <h1 className="text-lg font-bold leading-tight">DMS Admin</h1>
          <p className="text-xs text-blue-300 mt-0.5">Delivery Management System</p>
        </div>
        <div className="flex items-center gap-3 ml-auto">
          <div className="text-right hidden sm:block">
            <p className="text-sm font-semibold leading-tight">{user.name || 'Admin'}</p>
            <p className="text-xs text-blue-300 capitalize">{user.role || 'owner'}</p>
          </div>
          <button
            onClick={() => {
              const token = localStorage.getItem('dms_token');
              window.open(`https://dmswarehouse.jivini.in/?admin_token=${token}`, '_blank');
            }}
            className="px-3 py-1.5 text-xs font-semibold bg-blue-800 hover:bg-blue-700 rounded-lg transition-colors whitespace-nowrap"
          >
            🏭 Warehouse Portal
          </button>
          <button
            onClick={logout}
            className="px-3 py-1.5 text-xs font-semibold bg-blue-800 hover:bg-blue-700 rounded-lg transition-colors"
          >
            🚪 Logout
          </button>
        </div>
      </div>

      {/* Nav row: horizontal, scrolls sideways on narrow screens instead
          of wrapping into a tall block that would push content down. */}
      <nav className="flex gap-1 px-4 pb-2 overflow-x-auto border-t border-blue-800">
        {NAV.map(item => {
          const active = location.pathname.startsWith(item.path);
          return (
            <button
              key={item.path}
              onClick={() => navigate(item.path)}
              className={`flex items-center gap-2 px-3 py-2 mt-2 rounded-lg text-xs font-semibold whitespace-nowrap transition-colors
                ${active ? 'bg-blue-700 text-white' : 'text-blue-200 hover:bg-blue-800 hover:text-white'}`}
            >
              <span className="text-sm">{item.icon}</span>
              {item.label}
            </button>
          );
        })}
      </nav>
    </header>
  );
}

